/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Artifact_Updated_ByInputs */



/**
* | output |
* | --- |
* | "edited by {name}" |
*
* @param {Artifact_Updated_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_updated_by = /** @type {((inputs: Artifact_Updated_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Updated_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`bearbeitet von ${i?.name}`)
	return /** @type {LocalizedString} */ (`edited by ${i?.name}`)
});